import React, { createContext, useContext, useEffect, useState } from "react";
// import axios from "axios";
// import { apiurl } from "./config";
import { getCookie } from "./webStorage.js";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [storeData, setStoreData] = useState("");
  const [openProfile, setCloseProfile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [permissions, setPermissions] = useState(false);
  const [isPersonalize, setIsPersonalize] = useState(true);
  const [showSearch, setShowSearch] = useState(false);

  const token = getCookie("sctoken");

  const setUser = (user) => {
    setUserData(user);
  };
  useEffect(() => {
    setPermissions(userData?.permission);
    console.log("userData?.user?.permission");
  }, [userData]);

  const [showInternetStatus, setShowInternetStatus] = useState(false);

  // useEffect(() => {
  //   if (!navigator.onLine) {
  //     setShowInternetStatus(true);
  //   } else {
  //     setTimeout(() => {
  //       setShowInternetStatus(false);
  //     }, 10000);
  //   }
  // }, [navigator.onLine]);

  useEffect(() => {
    const handleOnline = () => {
      setShowInternetStatus(false);
    };

    const handleOffline = () => {
      setShowInternetStatus(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // initial check
    if (!navigator.onLine) {
      setShowInternetStatus(true);
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <UserContext.Provider
      value={{
        token,
        userData,
        setUser,
        storeData,
        setStoreData,
        openProfile,
        setCloseProfile,
        isMenuOpen,
        setIsMenuOpen,
        permissions,
        setPermissions,
        showInternetStatus,
        isPersonalize,
        setIsPersonalize,
        showSearch,
        setShowSearch,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};
